import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import ModalDocumentManagement from "./ModalDocumentManagement";
import Tooltip from '@material-ui/core/Tooltip';
import AlertModal from '../../../../shared/components/Modal';

const ListDocumentsActions = ({ data, id_estudio }) => {
    const history = useHistory();
    const doc = data.data.original;

    useEffect(() => {

    }, []);

    const showFile = () => {
        let url = `${process.env.REACT_APP_PUBLIC_URL}${doc.ruta}${sessionStorage.getItem('token')}`;
        window.open(url, '_blank');
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Ver Archivo">
                <IconButton style={{ fontSize: '15px' }} onClick={() => showFile()}>
                    <FontAwesomeIcon icon={faFileAlt} />
                </IconButton>
            </Tooltip>
        </td>
    </Fragment>)
}

export default ListDocumentsActions;